import { Flex, Text, useMantineTheme } from "@mantine/core";
import PasswordRequirementItem from "./PasswordRequirementItem";
import { useTranslation } from "react-i18next";

interface IProps {
  passwordOne: string;
  passwordTwo?: string;
}

const PasswordRequirements = ({ passwordOne, passwordTwo }: IProps) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={16}>
      <Text color={theme.colors.basic[4]} fs="14px">
        {t("global.password_requirements.title")}
      </Text>
      <Flex
        direction="row"
        gap={"10px 26px"}
        wrap="wrap"
        sx={{
          whiteSpace: "nowrap",
          fontSize: "14px",
        }}
      >
        <PasswordRequirementItem
          hasPasswordOne={!!passwordOne}
          satisfied={/[A-Z]/.test(passwordOne)}
          text={t("global.password_requirements.lower_case")}
        />
        <PasswordRequirementItem
          hasPasswordOne={!!passwordOne}
          satisfied={/[a-z]/.test(passwordOne)}
          text={t("global.password_requirements.upper_case")}
        />
        <PasswordRequirementItem
          hasPasswordOne={!!passwordOne}
          satisfied={/\d/.test(passwordOne)}
          text={t("global.password_requirements.number")}
        />
        <PasswordRequirementItem
          hasPasswordOne={!!passwordOne}
          satisfied={/[^a-zA-Z0-9]/.test(passwordOne)}
          text={t("global.password_requirements.special_character")}
        />
        <PasswordRequirementItem
          hasPasswordOne={!!passwordOne}
          satisfied={passwordOne.length >= 8}
          text={t("global.password_requirements.min_length")}
        />
        <PasswordRequirementItem
          hasPasswordOne={!!passwordOne}
          satisfied={passwordOne === passwordTwo}
          text={t("global.password_requirements.same_password")}
        />
      </Flex>
    </Flex>
  );
};

export default PasswordRequirements;
